exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-button-group[data-v-111131ca]{font-size:0;display:inline-block}.ck-button-group .ck-button[data-v-111131ca]{margin-right:-1px;border-radius:0}.ck-button-group .ck-button[data-v-111131ca]:hover{z-index:10}.ck-button-group .ck-button[data-v-111131ca]:first-of-type{border-top-left-radius:.5rem;border-bottom-left-radius:.5rem}.ck-button-group .ck-button[data-v-111131ca]:last-of-type{border-top-right-radius:.5rem;border-bottom-right-radius:.5rem}", ""]);

// exports
